module.exports = __webpack_public_path__ + "static/media/CreditMemo4.3a5ec6fc.png";